module.exports = __webpack_public_path__ + "public/media/developer-header.png";


//////////////////
// WEBPACK FOOTER
// ./images/services/developer-header.png
// module id = ./images/services/developer-header.png
// module chunks = 0